const riot = require('riot');

riot.tag2('atom-filter', '<div class="s-full bg-white rounded-4 p8 box-shadow"> <div class="text-label_low fs12 lh15 mb8">{currentItem.label}</div> <div if="{opts.type === &quot;tag&quot;}"> <div class="cursor-pointer"> <div class="text-label_high" if="{isSubmit}" onclick="{onTagFilter}"><span>#</span><span>{tagValue}</span></div> <form class="f fm input w-full p2" if="{!isSubmit}" onsubmit="{onTagSubmit}"> <div>#</div> <input ref="tag" oninput="{onInputTagValue}"> </form> </div> </div> </div>', '', '', function(opts) {
    this.isSubmit = false;
    this.filterType = [
      { id: 'project', label: 'プロジェクト' },
      { id: 'user', label: 'ユーザー' },
      { id: 'tag', label: 'タグ' },
      { id: 'date', label: '日付' },
    ];

    this.on('mount', () => {
      this.currentItem = this.filterType.find(item => item.id === this.opts.type);
      this.update();
    });

    this.onInputTagValue = (e) => {
      this.tagValue = e.currentTarget.value;
    };

    this.onTagSubmit = (e) => {
      e.preventDefault();
      if (!this.tagValue) return;

      this.isSubmit = true;
      this.update();
    };

    this.onTagFilter = (e) => {
      this.isSubmit = false;
      this.update();

      this.refs.tag.value = this.tagValue;
      this.refs.tag.focus();
    };

    this.setTagValue = (tag) => {
      this.tagValue = tag === 'undefined' ? '' : tag;
      if (this.tagValue) {
        this.isSubmit = true;
        this.update();
      }
    };
});